var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 36.5V44.33C50 47.5774 47.3674 50.21 44.12 50.21H9.88C6.63257 50.21 4 47.5774 4 44.33V36.5M50 36.5V9.88C50 6.63257 47.3674 4 44.12 4H27H9.88C6.63257 4 4 6.63257 4 9.88V36.5M50 36.5H4",
    stroke: "#8A96A3",
    strokeWidth: 6.82,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullView);
export default __webpack_public_path__ + "static/media/FullView.8f8fbf9f0e5ffa1bcd1cdfb86aded4d1.svg";
export { ForwardRef as ReactComponent };